import { DataListItem } from '@brighte/form-components';
import { CategoryComponent } from '@graphql/index';
import { ModifiedApplicationQuote, RelatedReferralWithSummary } from '@graphql/types';
import { FINANCE_PURCHASE } from '@utils';
import { formatPurchaseItem, getUnits } from './helpers';

function getCategoryComponentItems(categoryComponents: CategoryComponent) {
  const {
    pvPanelManufacturerSlug,
    inverterManufacturerSlug,
    batteryManufacturerSlug,
    walls,
    ceiling,
    floor,
    ...components
  } = categoryComponents;

  const insulationLocation = {
    ceiling,
    floor,
    walls,
  };

  const itemManufacturer = {
    pvPanelCapacity: pvPanelManufacturerSlug,
    inverterCapacity: inverterManufacturerSlug,
    batteryCapacity: batteryManufacturerSlug,
  };

  const componentItems = {
    ...components,
    ...(Object.values(insulationLocation).includes(true) && {
      insulationLocation,
    }),
  };

  return Object.entries(componentItems)
    .filter(item => item[1] !== null)
    .map(([key, value]) => {
      return {
        label: FINANCE_PURCHASE.CATEGORY_COMPONENTS[key] ?? '',
        value: formatPurchaseItem({
          value,
          unit: getUnits(key as keyof CategoryComponent),
          manufacturerSlug: itemManufacturer[key],
        }),
      };
    });
}

function getPurchaseDetails(quote: ModifiedApplicationQuote | RelatedReferralWithSummary): {
  title: string;
  items: DataListItem[];
} {
  const { productDescription, replacedProduct, category, categoryComponents } = quote;
  const items = category && categoryComponents ? getCategoryComponentItems(categoryComponents) : [];

  return {
    title: category.name,
    items: [
      ...items,
      ...(replacedProduct ? [{ label: 'Replaced Product', value: replacedProduct }] : []),
      ...(productDescription ? [{ label: productDescription }] : []),
    ],
  };
}

export default getPurchaseDetails;
